import React from "react";

export default function MySQL_MID() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_MID</h1>
      <p>This is the MySQL_MID component generated from the SQL JSON.</p>
    </div>
  );
}
